import axios from 'axios'
import '../utils/axios_retry_interceptor.js'
import { getCSRFToken } from '../utils/rails_helpers.js'

axios.defaults.headers.common['X-CSRF-Token'] = getCSRFToken()
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
